import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { useState } from 'react';
import { Avatar } from '../ui/Avatar';
import { useAuth } from '../../contexts/AuthContext';

const PERFIL_LABEL = { secretario: 'Secretário', comunicacao: 'Comunicação', admin: 'Administrador' };

export function Topbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [menu, setMenu] = useState(false);

  return (
    <header className="topbar">
      <div style={{ fontSize: 13, color: 'var(--c-text-muted)', fontWeight: 500 }}>
        {user?.secretaria_nome || 'Secretaria não atribuída'}
      </div>
      <div className="spacer" />
      <div style={{ position: 'relative' }}>
        <button
          className="btn btn-ghost"
          onClick={() => setMenu((v) => !v)}
          style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '6px 10px' }}
        >
          <Avatar nome={user?.nome} src={user?.foto} size="sm" />
          <div style={{ textAlign: 'left', lineHeight: 1.1 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--c-text)' }}>{user?.nome?.split(' ')[0]}</div>
            <div style={{ fontSize: 11, color: 'var(--c-text-muted)' }}>{PERFIL_LABEL[user?.perfil]}</div>
          </div>
        </button>
        {menu && (
          <>
            <div
              onClick={() => setMenu(false)}
              style={{ position: 'fixed', inset: 0, zIndex: 9 }}
            />
            <div className="card" style={{ position: 'absolute', right: 0, top: 48, minWidth: 220, zIndex: 10 }}>
              <div className="card-body" style={{ padding: 12 }}>
                <button className="btn btn-ghost btn-block" style={{ justifyContent: 'flex-start' }} onClick={() => { setMenu(false); nav('/perfil'); }}>
                  <User size={16} /> Meu perfil
                </button>
                <button className="btn btn-ghost btn-block" style={{ justifyContent: 'flex-start', color: 'var(--c-danger)' }} onClick={logout}>
                  <LogOut size={16} /> Sair
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
